'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import Guest from "./components/Guest.vue";

var _class = function _class() {
    _classCallCheck(this, _class);

    Vue.component('guest', Guest);
};

export default _class;


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/modules/checkout/components/guest/index.js
// module id = null
// module chunks = 